import { AfterViewInit, Component, ElementRef } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { ZIndexMngr } from '@core_n/common/ZIndexMngr';
import { DisplaySettings } from '../display-settings';
import { Animations } from '@core_n/Animations';

@Component({
  selector: 'maps-settings',
  templateUrl: './maps-settings.component.html',
  styleUrls: ['../display-filter.component.scss'],
  animations: [
    Animations.WindowOpenCloseFadeHeight
  ]
})
export class MapsSettingsComponent extends ZIndexMngr implements AfterViewInit {

  static DIALOG_ID = "mapsSettings";

  constructor(public dialogRef: MatDialogRef<MapsSettingsComponent>,
    elementRef: ElementRef) {
    super(elementRef);
  }
  
  ngAfterViewInit() {
    setTimeout(() => {
      this.windowVisible.next(true);
    })
  }
}
